import React from 'react';
import { Grid, Container } from '@mui/material';
import InfoGuide from './InfoGuide';

function Info({ lab }) {
    return (
        <Container sx={{ py: 4 }}>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <InfoGuide
                        guide={lab.guide || "NA"}
                        requirements={lab.requirements || []}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Info;
